import { environment } from './../environments/environment';
import { Component, OnDestroy } from '@angular/core';
import { NavigationEnd, NavigationStart, Router, RouterEvent } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { SessionTimeoutService } from './_services';
declare let gtag: Function;

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnDestroy {
  private readonly _routerEventsSubscription: Subscription;

  constructor(private router: Router, private sessionTimeoutService: SessionTimeoutService) {
    //
    // 1) reset the session timeout period
    // 2) reset scrollbar position to top once route navigation ends
    //
    this._routerEventsSubscription = this.router.events.subscribe(
      (event: RouterEvent): void => {
        if (event instanceof NavigationStart) {
          // reset session timer (if active)
          this.sessionTimeoutService.resetTimer();
          // NOTE: startTimer is called in login component
          // and stopTimer in either auth guard or dash component
        } else if (event instanceof NavigationEnd && event.url.indexOf('#') === -1) {
          const elSiteHeader = document.getElementById('topnav');
          if (elSiteHeader != null) {
            elSiteHeader.scrollIntoView({ behavior: 'instant', block: 'start' });
          }

          const elHeadingLevel1 = document.getElementsByTagName('h1');
          if (elHeadingLevel1 != null && elHeadingLevel1.length > 0) {
            elHeadingLevel1[0].focus();
          }
        }
        if(event instanceof NavigationEnd){
          gtag('config', environment.googleAnalyticsTrackingId, 
          {
            'page_path': event.urlAfterRedirects
          });
        }
      }
    );
  }

  ngOnDestroy(): void {
    this._routerEventsSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts